export default "__VITE_ASSET__BzT4QvIC__"